/* eslint-disable react-hooks/exhaustive-deps */
/**
 * B030051 入金EXCEL出力
 */
import { Box } from "@mui/material";
import {
  B030051ExcelRequest,
  B030051GetExcel,
  catchFileError,
} from "clients/rest";
import {
  msgState,
  SConfirmDialog,
  SDateField,
  SFileButton,
  SFrame,
  SLabel,
  SText,
} from "components";
import { getClientMessage } from "messages";
import { labels } from "messages/labels";
import { useEffect } from "react";
import { FormProvider, useForm } from "react-hook-form";
import { useNavigate } from "react-router-dom";
import { useRecoilValue, useSetRecoilState } from "recoil";
import { date, download } from "services";
import { focusState, useFocus } from "states";

// 呼び出し時のプロパティ
type Props = Partial<{}>;

// コンポーネントで設定されるフィールドの型を定義する
type Fields = Partial<{
  nyukinYmdFrom: string;
  nyukinYmdTo: string;
}>;

// フィールドの初期値を設定する。
const defaultFields: Fields = {
  nyukinYmdFrom: date(),
  nyukinYmdTo: date(),
};

const focusId = "B030051";

export const B030051 = (props: Props) => {
  useFocus(focusId);
  return <Page {...props} />;
};

const Page = (props: Props) => {
  // 状態管理の初期設定
  // フォーム関数
  const methods = useForm<Fields>({
    mode: "onBlur",
    defaultValues: defaultFields,
  });
  // フォーカス設定
  const { focus, register } = useRecoilValue(focusState(focusId));
  // 画面遷移
  const navigate = useNavigate();
  // エラー表示
  const setMsg = useSetRecoilState(msgState);

  // 初期表示イベント
  useEffect(() => {
    // 初回フォーカス先
    focus(1);
  }, []);

  // EXCELボタン押下時
  const handleClickExcelButton = () => {
    const fields = methods.getValues();

    const param: B030051ExcelRequest = {
      nyukinYmdFrom: fields.nyukinYmdFrom,
      nyukinYmdTo: fields.nyukinYmdTo,
    };

    B030051GetExcel(param)
      .then((response) => {
        download(response);
        setMsg(getClientMessage("B030051_001"));
      })
      .catch((reason) => {
        catchFileError(reason, navigate, setMsg);
      });
  };

  // レイアウト設定
  return (
    <FormProvider {...methods}>
      <SFrame
        title="入金EXCEL出力"
        gridTemplateColumns="5rem 9rem 1rem 9rem 5rem"
      >
        <SText gridColumn="span 5">　</SText>

        <SLabel>入金日</SLabel>
        <SDateField name="nyukinYmdFrom" {...register(1)} />

        <SText>～</SText>

        <SDateField name="nyukinYmdTo" {...register(2)} />
        <Box />

        <SText gridColumn="span 5">　</SText>
        <SText gridColumn="span 5">　</SText>
        <SText gridColumn="span 5">　</SText>

        <Box gridColumn="span 4" />
        <SFileButton
          label={labels.buttons.excel}
          align="right"
          {...register(3)}
          dialog={
            <SConfirmDialog
              title="入金EXCEL出力"
              msg={labels.dialog.masterExcelConfirmMessage}
            />
          }
          dialogAction="confirm"
          handleSubmit={handleClickExcelButton}
        />
      </SFrame>
    </FormProvider>
  );
};
